<template lang="pug">
  server-data(
    v-if="regionId"
    :method="$api.system.municipalities"
    :query="{ 'search[region_id]': this.regionId }"
    searchFieldName="search[name]"
    v-slot="{ selectProps, search, loadMoreItems }"
  )
    v-autocomplete-more(
      v-model="inputValue"
      v-bind="selectProps"
      name="municipality"
      label="Муниципалитет"
      filled
      rounded
      returnObject
      @update:search-input="search"
      @load-more-items="loadMoreItems"
    )
  //- v-autocomplete(
  //-   v-model="inputValue"
  //-   label="Муниципалитет(начните ввод)"
  //-   no-filter
  //-   item-text="name"
  //-   item-value="id"
  //-   hide-details
  //-   :search-input.sync="search"
  //-   :items="items"
  //-   v-bind="$attrs"
  //- )
</template>

<script>
export default {
  name: 'SelectMunitipality',
  props: {
    region: { type: Object, required: true },
    value: { type: [Object], default: null },
  },
  data() {
    return {
      regionId: null,
      items: [],
      search: '',
      cache: {},
    };
  },
  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  watch: {
    region: {
      handler(val) {
        if (val) {
          this.getRegion();
        }
      },
      immediate: true,
    },
  },
  methods: {
    async getRegion() {
      const { data } = await this.$api.system.regions({ 'search[code]': this.region.code });
      this.regionId = data.data[0].id;
      this.$emit('region', this.regionId);
    },
  },
};
</script>
